import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { Company } from '../../services/company-api.js';

@customElement('cp-company-card')
export class CpCompanyCard extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Object }) company!: Company;
  @property({ type: Number }) openTickets = 0;
  @property({ type: Number }) blockedStrategies = 0;

  private _handleClick() {
    this.dispatchEvent(new CustomEvent('company-selected', {
      detail: { companyId: this.company.id },
      bubbles: true,
      composed: true,
    }));
  }

  override render() {
    const { company } = this;
    const initials = company.name.split(' ').filter((w: string) => w.length > 0).map((w: string) => w[0]).join('').slice(0, 2).toUpperCase();
    const isDeactivated = company.status === 'deactivated';

    return html`
      <button
        class="cp-company-card ${isDeactivated ? 'cp-company-card--deactivated' : ''}"
        @click=${this._handleClick}
      >
        <div class="cp-company-card__header">
          <div
            class="cp-company-card__avatar"
            style="background-color: ${company.color ?? '#6B7280'}"
          >
            ${company.icon ?? initials}
          </div>
          <div class="cp-company-card__info">
            <p class="cp-company-card__name">${company.name}</p>
            <p class="cp-company-card__type">${company.type || 'Unternehmen'}</p>
          </div>
          ${isDeactivated ? html`
            <span class="cp-company-card__badge">Deaktiviert</span>
          ` : nothing}
          ${this.openTickets > 0 ? html`
            <span class="cp-company-card__notification cp-company-card__notification--warning">${this.openTickets}</span>
          ` : nothing}
          ${this.blockedStrategies > 0 ? html`
            <span class="cp-company-card__notification cp-company-card__notification--error">${this.blockedStrategies}</span>
          ` : nothing}
        </div>

        ${company.description ? html`
          <p class="cp-company-card__description">${company.description}</p>
        ` : nothing}

        <p class="cp-company-card__date">
          Erstellt: ${new Date(company.created_at).toLocaleDateString('de-DE')}
        </p>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-company-card': CpCompanyCard;
  }
}
